import { parse } from 'date-fns';
import { MONTH_FORMAT_DATE, SERVER_FORMAT_DATE } from '../constants/dates';

export const getDateByTimezone = (date: Date) => {
    return new Date(date.valueOf() + date.getTimezoneOffset() * 60 * 1000);
};

export const newDateFromString = (date: string | Date) => {
    const isString = typeof date === 'string';
    const isFullDate = !isString || date.split('-').length > 2;

    if (isString && !isFullDate) {
        return parse(date, MONTH_FORMAT_DATE, new Date()) || new Date();
    }

    return isString ? parse(date, SERVER_FORMAT_DATE, new Date()) || new Date() : date;
};
